
import { number } from 'echarts';
import { Editor } from "@/components";
// import tinymce from 'tinymce/tinymce'
// import Editor from '@tinymce/tinymce-vue'
import {
  pcaTextArr
} from "element-china-area-data";

    export default{

        components: {
			Editor,
		},

        data(){
            return{
                firstClassList:[],
                secondClassList:[],
                thirdClassList:[],
                level:1,
                parentCode:'',
                pcaTextArr,
                selectedOptions: [],
                value:{
                    firstClassName:'',
                    secondClassName:'',
                    thirdClassName:'',
                    name:'',
                    spec:'',
                    cashback:'',
                    post:'0',
                    stock:'',
                    goodsDesc:''
                },
                domains: [{
                    weight: '',
                    price:'',
                    key:Date.now(),
                }],
                imageUrl: '',
                pageNo:10,
                pageSize:1,
                tableData:[],
				content: '',
                isFreeShopping:'1',
                isPublished:'1',
				tinymceInit: {
				    language: 'zh_CN',
				    height: 500,
				    menubar: 'file edit view insert format tools table help',
				    toolbar: 'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat'
				}

            }
        },
        mounted() {
            
            this.getGoodsClass();
        },
        methods:{

            changeCode(data:any, type:any){

                this.parentCode = data;
                this.level = type; // 获取商品分类等级
                this.getGoodsClass();
            },
            handleChange() {
                console.log('地址选择器',this.selectedOptions);
            },
            addDomain(){
                // 新增规格
                this.domains.push({
                    key: Date.now()
                });
            },
            removeDomain(item){
                //删除规格
                var index = this.domains.indexOf(item)
                if(this.domains.length == 1) {
                    return;
                }
                if (index !== -1) {
                    this.domains.splice(index, 1)
                }
            },
            handleCancel(){

                // 取消
            },
            handleSure(){

                // 确定
                this.uploadData();
            },
            // 商品类型接口
            getGoodsClass(){

                let datas = [];
                let paramter = {};
                
                if(this.level == 1){

                    paramter = {
                        'name':1,
                        'pageSize':10000,
                        'ptLevel':this.level
                    };

                } else if(this.level == 2) {

                    paramter = {
                        'pageNum':1,
                        'pageSize':10000,
                        'ptLevel':this.level,
                        'parentCode':this.parentCode,
                    };

                } else {

                    paramter = {
                        'pageNum':1,
                        'pageSize':10000,
                        'ptLevel':this.level,
                        'parentCode':this.parentCode,
                    };
                }
                
                this.$http.get('productType/list',{params:paramter},{
                    emulateJSON:true }).then((result:any) =>{
                        datas = result.data.data.data;
                
                        if(this.level == 1) {

                            this.firstClassList = datas;
                        } else if(this.level == 2) {

                            this.secondClassList = datas;
                        } else {
                            this.thirdClassList = datas;
                        }
                })
            },
            // 接口上传
            uploadData(){
                
                let origin = this.selectedOptions[0]+'/'+this.selectedOptions[1]+'/'+this.selectedOptions[2];
                
                this.domains = this.domains.map(item => {
                    const { key, ...rest } = item;
                    return rest;
                });
                let isFreeShoppingBool = false;
                let isPublishedBool = false;
                if(this.isFreeShopping == 1) {

                    isFreeShoppingBool = true;
                }
                if(this.isPublished == 1) {

                    isPublishedBool = true;
                }
                let paramter = {
                        'origin':origin,
	  	                'name':this.value.name,
		                'description':this.value.goodsDesc,
                        'isFreeShipping':isFreeShoppingBool,
                        'isPublished':isPublishedBool,
                        'productCode':this.parentCode,
                        'shippingFee':this.value.post,
                        'stock' : this.value.stock,
                        'specifications' : this.domains
                    };
                this.$http.post("product", paramter).then((res:any) => {
    	            
                    if(res.data.code == 200){

                        this.$confirm('新增成功');
                        window.location.reload();
                        console.log(res.data);
                    }
                    
                });
            }
        }
    }
